export const users = {
  profile: {
    title: '個人資料',
    personalInfo: '個人資訊',
    securitySettings: '安全設定',
    activityHistory: '活動記錄',
    memberSince: '加入時間',
    changePassword: '更改密碼',
    currentPassword: '目前密碼',
    newPassword: '新密碼',
    confirmPassword: '確認密碼',
    updatePassword: '更新密碼',
    passwordRequired: '所有密碼欄位都是必填的',
    passwordMismatch: '密碼不符',
    passwordTooShort: '密碼必須至少 8 個字元',
    passwordUpdated: '密碼更新成功',
    passwordUpdateFailed: '密碼更新失敗',
    twoFactorAuth: '雙重驗證',
    enable2fa: '啟用雙重驗證',
    disable2fa: '停用雙重驗證',
    '2faEnabledText': '已啟用雙重驗證',
    '2faDisabledText': '已停用雙重驗證',
    '2faEnabled': '雙重驗證已啟用',
    '2faDisabled': '雙重驗證已停用',
    '2faToggleFailed': '切換雙重驗證失敗',
    setup2fa: '設定雙重驗證',
    '2faInstructions': '使用您的驗證器應用程式（Google Authenticator、Microsoft Authenticator 等）掃描此 QR 碼',
    manualEntry: '或手動輸入此代碼',
    verificationCode: '驗證碼',
    verifyAndEnable: '驗證並啟用',
    '2faSetupFailed': '設定雙重驗證失敗',
    '2faCodeRequired': '請輸入 6 位數驗證碼',
    '2faVerifyFailed': '驗證碼驗證失敗，請重試。',
    disable2faWarning: '停用雙重驗證將降低您的帳戶安全性。',
    enterPasswordToDisable: '請輸入您的密碼以確認：',
    '2faDisableFailed': '停用雙重驗證失敗',
    noActivity: '沒有最近的活動',
  },
};